import React from "react";
import { StyleSheet, Text, TextInput, View } from "react-native";

const CodeAccessState = ({ Icon, title, placeholder, type, setCode }) => {
  return (
    <View style={type === "compact" ? styles.containerCompact : styles.container}>
      {type === "compact" ?
        <View style={styles.contentCompact}>
          <Icon width={24} height={24} fill={"#000000"} stroke={"none"} />
          <Text style={styles.titleCompact}>{title}</Text>
        </View>
        : <View style={styles.content}>
          <View style={styles.icon}>
            <Icon width={24} height={24} fill={"#6724E2"} stroke={"none"} />
          </View>
          <Text style={styles.title}>{title}</Text>
        </View>}
      <TextInput
        style={{ ...styles.input }}
        placeholder={placeholder ?? "Ketik kode akses di sini"}
        placeholderTextColor={"#999"}
        onChangeText={(text) => {
          setCode(text);
        }}
        onChange={(e) => {
          setCode(e.target.value);
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  containerCompact: {
    flex: 1,
    justifyContent: "center",
  },
  content: {
    alignItems: "center",
  },
  contentCompact: {
    flexDirection: "row",
    gap: 8,
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: 20
  },
  icon: {
    width: 60,
    height: 60,
    padding: 18,
    borderRadius: 40,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "#E2DCFC",
    marginTop: 10
  },
  title: {
    fontFamily: "Archivo-Bold",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: 14,
    lineHeight: 15,
    marginTop: 24,
    marginBottom: 10,
    textAlign: "center",
  },
  titleCompact: {
    fontFamily: "Archivo-Bold",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: 14,
    lineHeight: 15,
    // marginTop: 24,
    // marginBottom: 10,
    textAlign: "left",
  },
  input: {
    fontFamily: "Archivo-SemiBold",
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: "500",
    border: "1px solid #EAEAEA",
    borderRadius: 10,
    textAlign: "center",
    width: "100%",
    padding: 10
  },
});

export default CodeAccessState;
